import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_nguonkinhphi, Lists_tinhchatnguonkp } from '../../../routes/menu'
import { Global, BaoCao } from '../../../shared/global';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-thamsobc-giaydenghirutvondautu_mau11edit',
  templateUrl: './giaydenghirutvondautu_mau11edit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./giaydenghirutvondautu_mau11edit.component.scss'],
  providers: [ListService, Repository]
})


export class giaydenghirutvondautu_mau11editComponent implements OnInit {

  msg: string;
  public chons: any = [
    { Id: 0, Ten: "Tạm ứng" },
    { Id: 1, Ten: "Thanh toán" },
  ];
  public ngaycancu: Date = null;
  public ngayphuluc: Date = null;
  public ngayklht: Date = null;
  public ngaydutoan: Date = null;

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any
  indLoading: boolean = false;
  modalTitle: any;
  doituongSelect: any = {
    Id: null, STK_VonTrongNuoc: null
    , STK_VonTrongNuoc_Tai: null
    , STK_VonNgoaiNuoc: null
    , STK_VonNgoaiNuoc_Tai: null
    , CanCuHD_So: null
    , CanCuHD_Ngay: null
    , PhuLuc_So: null
    , PhuLuc_Ngay: null
    , CanCu_KLHT_So: null
    , CanCu_KLHT_Ngay: null

    , CanCu_DuToan_So: null
    , CanCu_DuToan_Ngay: null

    , LK_GiaTri: null
    , SoDuTamUng: null
    , DeNghi: null
    , ThuocNguonVon: null
    , ThuocKeHoachVon: null
    , ThuHoiTamUng_TrongNuoc: null
    , ThuHoiTamUng_NgoaiNuoc: null
    , ThueGTGT_TrongNuoc: null
    , ThueGTGT_NgoaiNuoc: null
    , ChuyenTienBaoHanh_TrongNuoc: null
    , ChuyenTienBaoHanh_NgoaiNuoc: null
    , SoTraDVTH_TrongNuoc: null
    , SoTraDVTH_NgoaiNuoc: null
    , TenDVTH: null
    , SoTaiKhoan_DVTH: null
    , TaiKBNN: null
    , HienThiPhanGhiKBNN: null
    , KinhGui: null
    , ThanhToans: []
    , DonViId: null
  };
  nhomdtid: string = null;
  hoatdong: string = null;
  tabselected: number = 1;
  sobanghi: number;

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('modaltuychinhmaubc', { static: false }) modaltuychinhmaubc: ModalComponent;
  @ViewChild('dtsuamaubaocao', { static: false }) dtsuamaubaocao: any;
  @Output() save: EventEmitter<any> = new EventEmitter();



  constructor(private _dataService: ListService, private repo: Repository) {


  }

  ngOnInit(): void {

  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  currentUser: any;

  loadDataInit(idchungtu: any, donviid: string, loaigiaydenghi: any) {

      // loaigiaydenghi =0 hoac null: là giấy rút vốn đầu tư mẫu 11
    // loaigiaydenghi=1 là giấy đề nghị thanh toán vốn đầu tư 04a/TT


    this.ngaycancu = null;
    this.ngayphuluc = null;
    this.ngayklht = null;
    this.ngaydutoan = null;
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.id === idchungtu.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        this.modalTitle = giatri[0].ten_Phan_He;
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }

    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);
   
    this.doituongSelect = {
      Id: null, STK_VonTrongNuoc: null
      , STK_VonTrongNuoc_Tai: null
      , STK_VonNgoaiNuoc: null
      , STK_VonNgoaiNuoc_Tai: null
      , CanCuHD_So: null
      , CanCuHD_Ngay: null
      , PhuLuc_So: null
      , PhuLuc_Ngay: null
      , CanCu_KLHT_So: null
      , CanCu_KLHT_Ngay: null
      , LK_GiaTri: null
      , SoDuTamUng: null
      , DeNghi: null
      , ThuocNguonVon: null
      , ThuocKeHoachVon: null
      , ThuHoiTamUng_TrongNuoc: null
      , ThuHoiTamUng_NgoaiNuoc: null
      , ThueGTGT_TrongNuoc: null
      , ThueGTGT_NgoaiNuoc: null
      , ChuyenTienBaoHanh_TrongNuoc: null
      , ChuyenTienBaoHanh_NgoaiNuoc: null
      , SoTraDVTH_TrongNuoc: null
      , SoTraDVTH_NgoaiNuoc: null
      , TenDVTH: null
      , SoTaiKhoan_DVTH: null
      , TaiKBNN: null
      , HienThiPhanGhiKBNN: null
      , KinhGui: null
      , ThanhToans: []
      , DonViId: donviid
      , LoaiGiayDeNghi: loaigiaydenghi
    };



    this.repo.getRequest("api/doituong/giaydenghithanhtoanvondautu_chitiet/" + idchungtu)
      .subscribe(response => {
        this.doituongSelect.ThanhToans = response;
        console.log(this.doituongSelect.ThanhToans);
      });
    this.doituongSelect.Id = idchungtu;

    this.repo.getRequest("api/donvicauhinh/getthamsobyid/" + idchungtu)
      .subscribe(response => {
        if (response != null) {
          this.doituongSelect.STK_VonTrongNuoc = response.STK_VonTrongNuoc;
          this.doituongSelect.STK_VonTrongNuoc_Tai = response.STK_VonTrongNuoc_Tai;
          this.doituongSelect.STK_VonNgoaiNuoc = response.STK_VonNgoaiNuoc;
          this.doituongSelect.STK_VonNgoaiNuoc_Tai = response.STK_VonNgoaiNuoc_Tai;
          this.doituongSelect.CanCuHD_So = response.CanCuHD_So;
          if (response.CanCuHD_Ngay != null)
            this.ngaycancu = new Date(response.CanCuHD_Ngay);
          else
            this.doituongSelect.CanCuHD_Ngay = null;

          this.doituongSelect.PhuLuc_So = response.PhuLuc_So;

          if (response.PhuLuc_Ngay != null)
            this.ngayphuluc = new Date(response.PhuLuc_Ngay);
          else
            this.doituongSelect.PhuLuc_Ngay = null;

          
          this.doituongSelect.CanCu_KLHT_So = response.CanCu_KLHT_So;
          
          if (response.CanCu_KLHT_Ngay != null)
            this.ngayklht = new Date(response.CanCu_KLHT_Ngay);
          else
            this.doituongSelect.CanCu_KLHT_Ngay = null;

          this.doituongSelect.CanCu_DuToan_So = response.CanCu_DuToan_So;

          if (response.CanCu_DuToan_Ngay != null)
            this.ngaydutoan = new Date(response.CanCu_DuToan_Ngay);
          else
            this.doituongSelect.CanCu_DuToan_Ngay = null;

          this.doituongSelect.LK_GiaTri = response.LK_GiaTri;
          this.doituongSelect.SoDuTamUng = response.SoDuTamUng;
          this.doituongSelect.DeNghi = response.DeNghi;
          this.doituongSelect.ThuocNguonVon = response.ThuocNguonVon;
          this.doituongSelect.ThuocKeHoachVon = response.ThuocKeHoachVon;
          this.doituongSelect.ThuHoiTamUng_TrongNuoc = response.ThuHoiTamUng_TrongNuoc;
          this.doituongSelect.ThuHoiTamUng_NgoaiNuoc = response.ThuHoiTamUng_NgoaiNuoc;
          this.doituongSelect.ThueGTGT_TrongNuoc = response.ThueGTGT_TrongNuoc;
          this.doituongSelect.ThueGTGT_NgoaiNuoc = response.ThueGTGT_NgoaiNuoc;
          this.doituongSelect.ChuyenTienBaoHanh_TrongNuoc = response.ChuyenTienBaoHanh_TrongNuoc;
          this.doituongSelect.ChuyenTienBaoHanh_NgoaiNuoc = response.ChuyenTienBaoHanh_NgoaiNuoc;
          this.doituongSelect.SoTraDVTH_TrongNuoc = response.SoTraDVTH_TrongNuoc;
          this.doituongSelect.SoTraDVTH_NgoaiNuoc = response.SoTraDVTH_NgoaiNuoc;
          this.doituongSelect.TenDVTH = response.TenDVTH;
          this.doituongSelect.SoTaiKhoan_DVTH = response.SoTaiKhoan_DVTH;
          this.doituongSelect.TaiKBNN = response.TaiKBNN;
          this.doituongSelect.HienThiPhanGhiKBNN = response.HienThiPhanGhiKBNN;
          this.doituongSelect.KinhGui = response.KinhGui;
          //console.log("taitai2222");
          //console.log(this.doituongSelect.CanCuHD_Ngay);
          //console.log(response.CanCuHD_Ngay);
        }
        else { 
          this.doituongSelect.HienThiPhanGhiKBNN = false;
          this.doituongSelect.DonViId = donviid;
          this.doituongSelect.DeNghi = 0;
        }
        
      });

    

    


  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  //public saveproduct() {

  //  this.repo.postRequest("api/doituong/addorupdate", this.doituongSelect)
  //    .subscribe(response => {
  //      console.log(response);
  //      this.doituongSelect.Id = response;
  //      this.save.emit(this.doituongSelect);
  //    });

  //}
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };
  itemrow: any;
  public changerange(row: any) {
    if (this.doituongSelect.ThanhToans != null) {
      //for (let i: number = 0; i < this.doituongSelect.ThanhToans.length; i = i + 1) {
      //  this.itemrow = this.doituongSelect.ThanhToans[i];
      //  if (this.itemrow.IDCHUNGTU == row.IDCHUNGTU && row.NOPTHUE != null && this.itemrow.SOTIENDK!=null) {
      //      this.doituongSelect.ThanhToans[i].DONVIHUONG = this.doituongSelect.ThanhToans[i].SOTIENDK - this.doituongSelect.ThanhToans[i].NOPTHUE;
      //  }
      //}
    }
  }
  public tuychinhmaubaocao() {

    if (this.doituongSelect.LoaiGiayDeNghi == null || this.doituongSelect.LoaiGiayDeNghi == 0) {
      this.dtsuamaubaocao.loadDataInit('0CC3585C-D660-4425-925B-06F09B3009D9');
      this.modaltuychinhmaubc.open();
    }
    if (this.doituongSelect.LoaiGiayDeNghi == 1) {
      this.dtsuamaubaocao.loadDataInit('63418AB5-8B1B-4079-BCBE-52A1755FE096');
      this.modaltuychinhmaubc.open();
    }

    
  }
  public export(kieuin) {
    $('#loading').show();

    if (this.ngaycancu != null) {
      this.doituongSelect.CanCuHD_Ngay = this.ngaycancu.getDate() + '/' + (this.ngaycancu.getMonth() + 1) + '/' + this.ngaycancu.getFullYear();
    }
    else
      this.doituongSelect.CanCuHD_Ngay = null;

    if (this.ngayphuluc != null) {
      this.doituongSelect.PhuLuc_Ngay = this.ngayphuluc.getDate() + '/' + (this.ngayphuluc.getMonth() + 1) + '/' + this.ngayphuluc.getFullYear();
    }
    else
      this.doituongSelect.PhuLuc_Ngay = null;

    if (this.ngayklht != null) {
      this.doituongSelect.CanCu_KLHT_Ngay = this.ngayklht.getDate() + '/' + (this.ngayklht.getMonth() + 1) + '/' + this.ngayklht.getFullYear();
    }
    else
      this.doituongSelect.CanCu_KLHT_Ngay = null;

    if (this.ngaydutoan != null) {
      this.doituongSelect.CanCu_DuToan_Ngay = this.ngaydutoan.getDate() + '/' + (this.ngaydutoan.getMonth() + 1) + '/' + this.ngaydutoan.getFullYear();
    }
    else
      this.doituongSelect.CanCu_DuToan_Ngay = null;



    let data = {
      Id: '0CC3585C-D660-4425-925B-06F09B3009D9', // id cứng trong FunctionConstants để điều hướng đến hàm giay rút dự toán
      Type: kieuin,
      Data: JSON.stringify(this.doituongSelect)
    };

    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          $('#loading').hide();
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "giaydenghithanhtoanvondautu.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            $('#loading').hide();
            //this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
            //  data => {
            //    $('#loading').hide();
            //  },
            //  error => {
            //    this.msg = error;
            //  }
            //);
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }
    


  }


  export_xml(loaiphieu) {
    //loaiphieu=1 giấy rút mẫu 02
    //loaiphieu=2 giấy rút mẫu 02b
    //loaiphieu=3 Bảng kê chứng từ thanh toán tạm ứng
    //loaiphieu=4 giấy đề nghị thanh toán tạm ứng

    $('#loading').show();
    let datatt = {
      Id: null,
      Type: null,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , IdChungTu: this.doituongSelect.Id
        , LoaiPhieu: loaiphieu
        
      })
    };


    this.repo.postRequest("api/baocao/ketnoikbnn_vondautu_mau11/", datatt)
      .subscribe(response => {
        $('#loading').hide();
        if (response.TrangThai = "OK") {
          location.href = "/Logs/Reports/" + response.DuongDan;
        }
        else
          swal('Cảnh báo!', response.TrangThai, 'warning');
      });



  }




}
